import React from 'react';
import {
  Label,
} from 'semantic-ui-react';

const RESTRICTIONS = [
  {minAge: 0, color: 'teal'},
  {minAge: 6, color: 'green'},
  {minAge: 9, color: 'green'},
  {minAge: 12, color: 'olive'},
  {minAge: 14, color: 'olive'},
  {minAge: 16, color: 'orange'},
  {minAge: 18, color: 'red'}
];

class AgeRestriction extends React.Component{

  render(){
    let restriction = RESTRICTIONS[0];
    for(let i=1; i < RESTRICTIONS.length; i++){
      if(this.props.age >= RESTRICTIONS[i].minAge) restriction = RESTRICTIONS[i];
    }
    return (
      <Label color={restriction.color}>Empfohlen ab {restriction.minAge} Jahren</Label>
    );
  }
}


export default AgeRestriction;


// WEBPACK FOOTER //
// ./src/components/AgeRestriction.js